// Keeps a circle (a person or a vehicle) out of building footprints.
// A collider is { p: flat [x, z, ...] polygon, minX, minZ, maxX, maxZ }.
import { pointInPolygon } from './clip.js';

// Returns the corrected position { x, z, hit }.
export function resolveCircle(x, z, radius, colliders) {
  let hit = false;
  for (let pass = 0; pass < 2; pass++) {
    for (const c of colliders) {
      if (x < c.minX - radius || x > c.maxX + radius || z < c.minZ - radius || z > c.maxZ + radius) continue;
      const p = c.p;
      let bestD = Infinity;
      let bx = 0;
      let bz = 0;
      for (let i = 0, n = p.length; i < n; i += 2) {
        const j = (i + 2) % n;
        const ex = p[j] - p[i];
        const ez = p[j + 1] - p[i + 1];
        const len2 = ex * ex + ez * ez || 1;
        let t = ((x - p[i]) * ex + (z - p[i + 1]) * ez) / len2;
        t = t < 0 ? 0 : t > 1 ? 1 : t;
        const qx = p[i] + ex * t;
        const qz = p[i + 1] + ez * t;
        const d = (x - qx) * (x - qx) + (z - qz) * (z - qz);
        if (d < bestD) {
          bestD = d;
          bx = qx;
          bz = qz;
        }
      }
      const d = Math.sqrt(bestD);
      const inside = pointInPolygon(x, z, p);
      if (!inside && d >= radius) continue;
      hit = true;
      if (d < 1e-6) continue;
      // outside: back off along the line from the wall; inside: cross the nearest wall
      const push = inside ? d + radius : radius - d;
      const dir = inside ? -1 : 1;
      x += ((x - bx) / d) * push * dir;
      z += ((z - bz) / d) * push * dir;
    }
  }
  return { x, z, hit };
}
